import "./App.css";
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import marker2x from 'leaflet/dist/images/marker-icon-2x.png';
import marker from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Places from "./pages/Places";
import PlaceDetail from "./pages/PlaceDetail";
import AddPlace from "./pages/AddPlace";
import Channels from "./pages/Channels";
import ChannelDetail from "./pages/ChannelDetail";
import Profile from "./pages/Profile";
import AdminDashboard from "./pages/AdminDashboard";
import Subscription from "./pages/Subscription";
import PostDetail from "./pages/PostDetail";
import Messages from "./pages/Messages";
import TripPlanner from "./pages/TripPlanner";
import Conditions from "./pages/Conditions";
import Festivals from "./pages/Festivals";
import Chatbot from "./pages/Chatbot";

// Fix for default marker icon in react-leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: marker2x,
  iconUrl: marker,
  shadowUrl: markerShadow
});

window.deferredPrompt = null;

function App() {
  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      window.deferredPrompt = e;
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/subscribe" element={<Subscription />} />
            <Route path="/places"        element={<ProtectedRoute requiresPremium><Places /></ProtectedRoute>} />
            <Route path="/places/add"    element={<ProtectedRoute requiresPremium><AddPlace /></ProtectedRoute>} />
            <Route path="/places/:id"    element={<ProtectedRoute requiresPremium><PlaceDetail /></ProtectedRoute>} />
            <Route path="/place/:id"     element={<ProtectedRoute requiresPremium><PlaceDetail /></ProtectedRoute>} />
            <Route path="/channels"      element={<ProtectedRoute requiresPremium><Channels /></ProtectedRoute>} />
            <Route path="/channels/:id"  element={<ProtectedRoute requiresPremium><ChannelDetail /></ProtectedRoute>} />
            <Route path="/posts/:id"     element={<ProtectedRoute requiresPremium><PostDetail /></ProtectedRoute>} />
            <Route path="/messages"      element={<ProtectedRoute requiresPremium><Messages /></ProtectedRoute>} />
            <Route path="/trip-ai"       element={<ProtectedRoute requiresPremium><TripPlanner /></ProtectedRoute>} />
            <Route path="/conditions"    element={<ProtectedRoute requiresPremium><Conditions /></ProtectedRoute>} />
            <Route path="/festivals"     element={<ProtectedRoute requiresPremium><Festivals /></ProtectedRoute>} />
            <Route path="/giri-ai"       element={<ProtectedRoute requiresPremium><Chatbot /></ProtectedRoute>} />
            <Route path="/profile"       element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/profile/:id"   element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/admin"         element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;